import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { HomeFilters } from '@sales-app/context/workspace/workspace.type'
import { DisplayCitiesQueries } from '@sales-app/graphql/queries/displayCities.queries'
import { DisplayCity } from '@sales-app/types/DisplayCity'
import debounce from 'debounce-promise'
import { Form, Formik } from 'formik'
import React, { FC } from 'react'

import { InputSelect } from '@/components'
import { graphQLClient } from '@/hooks/useGraphql'

type Props = {
  currentFilters: HomeFilters
}

export const MarketSelection: FC<Props> = ({ currentFilters }) => {
  const { displayCity } = currentFilters
  const debouncedSearchCity = debounce(searchCity, 1000, { leading: true })
  const [, WorkspaceDispatch] = useWorkspaceContext()

  const loadCityOptions = (inputValue) => debouncedSearchCity(inputValue)
  const handleSubmit = async (values: { displayCity: number }) => {
    if (values.displayCity) {
      const displayCity = await getDisplayCity(values.displayCity)
      WorkspaceDispatch(WorkspaceAction.updateFilters({ displayCity }))
    }
  }
  return (
    <Formik
      initialValues={{
        displayCity: displayCity?.id,
      }}
      onSubmit={handleSubmit}
    >
      {({ submitForm }) => {
        return (
          <Form className=" flex w-1/2 flex-row flex-wrap">
            <InputSelect
              async={true}
              className="w-full"
              defaultOptions={false}
              id="displayCity"
              loadOptions={loadCityOptions}
              name="displayCity"
              nullLabel="---"
              onChange={submitForm}
              onClear={() => WorkspaceDispatch(WorkspaceAction.updateFilters({ displayCity: undefined }))}
              optionValue={displayCity ? { label: displayCity?.name || '', value: displayCity?.slug } : undefined}
              overviewDropdown={true}
            />
          </Form>
        )
      }}
    </Formik>
  )
}

const searchCity = (inputValue: string) => {
  return graphQLClient
    .request<any>(DisplayCitiesQueries.getDisplayCities(), {
      filter: { name: inputValue },
    })
    .then((resRespons) => {
      return resRespons.displayCities.map((city: DisplayCity) => ({
        label: `${city.name}, ${city.regionAbbreviation}`,
        value: city.id,
      }))
    })
}

const getDisplayCity = async (id: number) => {
  const resRespons = await graphQLClient.request<any>(DisplayCitiesQueries.getDisplayCity(), {
    displayCityId: id,
  })
  return resRespons.displayCity as DisplayCity
}
